import routes from '@/modules/movement/routes'
import store from '@/modules/movement/store'

export default { routes, store }
